import * as React from "react"
import { createOldValue, IHandleChangeProps } from "../../../models"
import FormField from "../form-field-generator"

const UncommonFields = ({
  ean,
  lockable,
  manufacturerRef,
  supplierRef,
  isNewProduct,
  boolTopRef,
  tabIndex,
  handleChangeStandardField,
  handleStandardFieldLockClick,
  onFieldLooseFocus,
  translations,
  previousVersion,
  selectedPreviousVersion = null,
}: any) => {
  const preventSpaces = (payload: IHandleChangeProps) => {
    const { fieldValue } = payload
    const result =
      typeof fieldValue === "string"
        ? (fieldValue as string).trim()
        : fieldValue
    handleChangeStandardField({ ...payload, fieldValue: result })
  }
  console.log(isNewProduct)
  return (
    <section className="text-field-div top-three">
      <FormField
        isNewProduct={isNewProduct}
        lockable={lockable}
        tabIndex={tabIndex++}
        label={translations.productReferenceLabel}
        disabled={boolTopRef}
        onChange={preventSpaces}
        data={boolTopRef ? "" : supplierRef}
        oldValue={createOldValue(
          selectedPreviousVersion,
          previousVersion?.supplierRef,
          previousVersion
        )}
        onFieldLooseFocus={onFieldLooseFocus}
        onLockClick={handleStandardFieldLockClick}
      />
      <FormField
        isNewProduct={isNewProduct}
        lockable={lockable}
        tabIndex={tabIndex++}
        label={translations.productReferenceManufacturerLabel}
        onChange={handleChangeStandardField}
        disabled={boolTopRef}
        data={manufacturerRef}
        oldValue={createOldValue(
          selectedPreviousVersion,
          previousVersion?.manufacturerRef,
          previousVersion
        )}
        placeholder={boolTopRef ? "" : supplierRef.value}
        onFieldLooseFocus={onFieldLooseFocus}
        onLockClick={handleStandardFieldLockClick}
      />
      <FormField
        isNewProduct={isNewProduct}
        lockable={lockable}
        tabIndex={tabIndex++}
        label={translations.productCodeLabel}
        onChange={handleChangeStandardField}
        data={ean}
        oldValue={createOldValue(
          selectedPreviousVersion,
          previousVersion?.ean,
          previousVersion
        )}
        disabled={boolTopRef}
        onFieldLooseFocus={onFieldLooseFocus}
        onLockClick={handleStandardFieldLockClick}
      />
    </section>
  )
}

export default UncommonFields
